import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import ColorModeContext from "../../layout/themeContext";
import defaultLogoLight from "../../assets/logo.png";
import defaultLogoDark from "../../assets/logo-black.png";
import useSettings from "../../hooks/useSettings";
import {
  HEADER_CONFIG_SETTING_KEY,
  parseHeaderConfig,
} from "../../utils/headerConfig";

const Logo = ({ className = "", linkTo = "/tickets", size = "medium" }) => {
  const theme = useContext(ColorModeContext);
  const { get } = useSettings();
  const [imgError, setImgError] = useState(false);
  const [headerConfig, setHeaderConfig] = useState(() => parseHeaderConfig());

  useEffect(() => {
    let mounted = true;

    get(HEADER_CONFIG_SETTING_KEY)
      .then((setting) => {
        if (mounted) setHeaderConfig(parseHeaderConfig(setting?.value));
      })
      .catch(() => {
        if (mounted) setHeaderConfig(parseHeaderConfig());
      });

    return () => {
      mounted = false;
    };
  }, [get]);

  const getLogo = () => {
    if (theme.mode === "light") {
      return imgError
        ? defaultLogoLight
        : theme.appLogoLight || defaultLogoLight;
    } else {
      return imgError ? defaultLogoDark : theme.appLogoDark || defaultLogoDark;
    }
  };

  const sizeMap = {
    small: { height: "24px", maxWidth: "120px" },
    medium: { height: "32px", maxWidth: "160px" },
    large: { height: "40px", maxWidth: "200px" },
  };

  const handleError = () => {
    console.log("Erro ao carregar logo, usando fallback");
    setImgError(true);
  };

  const TextLogo = () => (
    <div
      className="text-logo"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: sizeMap[size].height,
        minWidth: "80px",
        maxWidth: sizeMap[size].maxWidth,
        backgroundColor:
          theme.mode === "light"
            ? theme.primaryColorLight
            : theme.primaryColorDark,
        color: "white",
        fontWeight: "bold",
        borderRadius: "5px",
        padding: "0 12px",
        fontSize:
          size === "small" ? "12px" : size === "medium" ? "14px" : "16px",
      }}
    >
      {theme.appName || "Lead Pro"}
    </div>
  );

  const logoUrl = getLogo();

  return (
    <Link to={linkTo === "/tickets" ? headerConfig.logoLink : linkTo} className={`logo-link ${className}`}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={theme.appName || "Lead Pro"}
          className="logo-img"
          style={{
            height: sizeMap[size].height,
            maxWidth: sizeMap[size].maxWidth,
            objectFit: "contain",
          }}
          onError={handleError}
        />
      ) : (
        <TextLogo />
      )}
    </Link>
  );
};

export default Logo;
